import PublicNav from '@/components/layout/PublicNav';
import PublicFooter from '@/components/layout/PublicFooter';
import { useSEO } from '@/hooks/useSEO';

export default function TermsPage() {
  useSEO({ title: 'Terms of Service — YuHasPro', description: 'Terms and conditions for using the YuHasPro platform.' });

  return (
    <div className="bg-background text-foreground min-h-screen">
      <PublicNav />
      <main className="pt-28 pb-20 px-6 lg:px-12 max-w-3xl mx-auto">
        <h1 className="font-display text-3xl font-extrabold tracking-tight mb-8">Terms of Service</h1>
        <div className="prose prose-sm text-muted-foreground space-y-6 text-[13px] leading-relaxed">
          <p><strong>Last updated:</strong> March 2026</p>

          <h2 className="font-display text-lg font-bold text-foreground mt-8 mb-3">1. Acceptance of Terms</h2>
          <p>By accessing or using YuHasPro, you agree to be bound by these Terms of Service. If you do not agree, do not use the platform.</p>

          <h2 className="font-display text-lg font-bold text-foreground mt-8 mb-3">2. Use of Service</h2>
          <p>YuHasPro provides a CRM platform for educational institutions. You are responsible for maintaining the confidentiality of your account credentials and for all activity under your account.</p>

          <h2 className="font-display text-lg font-bold text-foreground mt-8 mb-3">3. Data Ownership</h2>
          <p>You retain full ownership of all data you upload or enter into YuHasPro. We do not claim any intellectual property rights over your content.</p>

          <h2 className="font-display text-lg font-bold text-foreground mt-8 mb-3">4. Service Availability</h2>
          <p>We strive for 99.9% uptime but do not guarantee uninterrupted service. Scheduled maintenance windows will be communicated in advance.</p>

          <h2 className="font-display text-lg font-bold text-foreground mt-8 mb-3">5. Payment Terms</h2>
          <p>Paid plans are billed monthly or annually. Refunds are available within 14 days of initial purchase. Failure to pay may result in service suspension.</p>

          <h2 className="font-display text-lg font-bold text-foreground mt-8 mb-3">6. Termination</h2>
          <p>Either party may terminate this agreement with 30 days written notice. Upon termination, you may export your data within 30 days.</p>

          <h2 className="font-display text-lg font-bold text-foreground mt-8 mb-3">7. Limitation of Liability</h2>
          <p>YuHasPro shall not be liable for any indirect, incidental, or consequential damages arising from your use of the platform.</p>

          <h2 className="font-display text-lg font-bold text-foreground mt-8 mb-3">8. Governing Law</h2>
          <p>These terms are governed by the laws of India. Any disputes shall be subject to the jurisdiction of courts in Bangalore, India.</p>

          <h2 className="font-display text-lg font-bold text-foreground mt-8 mb-3">9. Contact</h2>
          <p>For questions about these terms, contact us at <strong>legal@yuhaspro.in</strong>.</p>
        </div>
      </main>
      <PublicFooter />
    </div>
  );
}
